import { AppModule } from '@app/types';
import StreamerBoxIcon from './components/StreamerBoxIcon';

export const StreamerBoxModule: AppModule = {
  id: 'streamerBox',
  icon: <StreamerBoxIcon />,
  title: 'StreamerBox',
  basePath: 'streamer-box',
};
